// Admission-circular
export const circularListApi = 'admission-management/admission-circular/list'
export const requestCircularListApi = 'admission-management/admission-circular/request-list'
export const approveOrPublishListApi = 'admission-management/admission-circular/approved-published-list'
export const circularStoreApi = 'admission-management/admission-circular/store'
export const circularUpdateApi = 'admission-management/admission-circular/update'
export const circularToggleStatusApi = 'admission-management/admission-circular/toggle-status'
export const circularForwardApi = 'admission-management/admission-circular/forward-update'
export const circularApproveDenyApi = 'admission-management/admission-circular/approve-deny'

// OnlineAdmission
export const onlineAdmissionList = 'admission-management/online-admission/list'
export const onlineAdmissionStore = 'admission-management/online-admission/store'
export const onlineAdmissionUpdate = 'admission-management/online-admission/update'
export const onlineAdmissionDetails = 'admission-management/online-admission/details'

// Applicant Assesment
export const assessmentToolsListApi = 'configuration/assessment-tools/list'
export const applicantAssessmentListApi = 'admission-management/applicant-assessment/list'
export const applicantAssessmentStoreApi = 'admission-management/applicant-assessment/store'
export const applicantAssessmentEditApi = 'admission-management/applicant-assessment/edit'
export const applicantAssessmentDetailApi = 'admission-management/applicant-assessment/show'
export const applicantAssessmentUpdateApi = 'admission-management/applicant-assessment/update'

// Applicant Approval
export const approveApplicantApi = 'admission-management/admission-fee/applicant-approve'

// Admission Fee Api
export const admissionFeeList = 'admission-management/admission-fee/list'
export const admissionFeeStoreApi = 'admission-management/admission-fee/store'
export const admissionFeeUpdateApi = 'admission-management/admission-fee/update'
export const admissionFeeDetails = 'admission-management/admission-fee/show'
export const getApplicantByMobileApi = 'admission-management/admission-fee/applicant-by-mobile'

// Nothi api
export const nothi = 'nothi/'
export const pendingNothiApplicantApi = nothi + 'applicant-sent-nothi'
export const reSentNothiApplicantApi = nothi + 'applicant-re-sent-nothi'
